document.addEventListener("DOMContentLoaded", function () {
  const checkoutBtn = document.getElementById("cart-checkout");
  if (!checkoutBtn) return;

  checkoutBtn.addEventListener("click", function (e) {
    if (checkoutBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    // Disable ngay để chặn double click
    checkoutBtn.disabled = true;
    checkoutBtn.style.opacity = "0.6";
    checkoutBtn.style.cursor = "not-allowed";

    // Re-enable sau 5 giây (phòng trường hợp fail)
    setTimeout(() => {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = "1";
      checkoutBtn.style.cursor = "pointer";
    }, 5000);
  });
});
